import { render } from "./ComponenteDiagrama.vue?vue&type=template&id=b451d64c&scoped=true"
import script from "./ComponenteDiagrama.vue?vue&type=script&lang=js"
export * from "./ComponenteDiagrama.vue?vue&type=script&lang=js"

import "./ComponenteDiagrama.vue?vue&type=style&index=0&id=b451d64c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b451d64c"]])

export default __exports__